var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { checkType, CheckType, upperCase } from './shared';
let views = '';
let container = '';
function createElementString(children) {
    if (!children || !Array.isArray(children) || children.length === 0) {
        return '\n';
    }
    for (const iterator of children) {
        const _a = iterator.props, { children, className, style } = _a, other = __rest(_a, ["children", "className", "style"]);
        views += `  <${upperCase(iterator.type)}${createAttributesString(iterator.key, className, style, other)}> \n`;
        views += createElementString(children);
        views += `  </${upperCase(iterator.type)}>\n`;
    }
    return views;
}
function createAttributesString(key, className, style, other) {
    let attrs = '';
    if (checkType(key) !== CheckType.Undefined) {
        if (checkType(key) === CheckType.String || checkType(key) === CheckType.Number) {
            attrs += `key='${key}'`;
        }
        else {
            attrs += `key={${key}}`;
        }
    }
    if (className) {
        attrs += `className='${className}' `;
    }
    if (checkType(style) === CheckType.Object) {
        const styleKeys = Object.keys(style);
        const end = styleKeys.length - 1;
        let cursor = 0;
        attrs += `style={{`;
        for (const cssKey of styleKeys) {
            const cssValue = style[cssKey];
            if (cursor === end) {
                attrs += `${cssKey}:'${cssValue}'`;
                break;
            }
            attrs += `${cssKey}:'${cssValue}',`;
            cursor++;
        }
        attrs += '}} ';
    }
    if (checkType(other) === CheckType.Object) {
        const otherKeys = Object.keys(other);
        for (const otherKey of otherKeys) {
            const otherValue = other[otherKey];
            if (typeof otherValue === 'object') {
                attrs += `${otherKey}={${JSON.stringify(otherValue)}} `;
            }
            else if (otherValue === undefined || otherValue === null) {
                attrs += `${otherKey}={${otherValue}} `;
            }
            else if (typeof otherValue === 'number' || typeof otherValue === 'function') {
                attrs += `${otherKey}={${otherValue}} `;
            }
            else {
                attrs += `${otherKey}='${otherValue}' `;
            }
        }
    }
    if (attrs.length > 0) {
        attrs = ' ' + attrs;
    }
    return attrs;
}
/**
 * 传入一个 CoMallElement 元素，并返回一个 `JSX` 格式的快照
 * @param tree
 */
function createSnapshot(tree) {
    views = '';
    container = '';
    const { type, props, key } = tree;
    const { children, className, style } = props, other = __rest(props, ["children", "className", "style"]);
    container = `<${upperCase(type)}${createAttributesString(key, className, style, other)}> \n`;
    container += createElementString(children);
    container += `</${upperCase(type)}>`;
    return container;
}
export default createSnapshot;
//# sourceMappingURL=createSnapshot.js.map